import script from "./ApprovalSubmitDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalSubmitDialog.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalSubmitDialog.vue?vue&type=style&index=0&id=5700fb64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5700fb64"]])

export default __exports__